<template>
  <v-app :class="{ transparent: $router.currentRoute.meta.transparentBackground }">
    <v-toolbar v-if="!$route.meta.isOverlay" class="flex-grow-0">
      <!-- Desktop nav -->
      <v-row
        justify="center"
        no-gutters
        class="hidden-sm-and-down"
      >
        <v-col
          class="py-4 text-center white--text thofu-menu"
          cols="12"
        >
          <v-btn :to="'/'">Home</v-btn>
          <v-btn :to="{name: 'pricing'}">Funktionen</v-btn>
          <v-btn v-if="showShop" :to="{name: 'shop'}">Shop</v-btn>
          <v-btn :to="{name: 'about'}">Über uns</v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                v-bind="attrs"
                v-on="on"
              >
                Community
              </v-btn>
            </template>
            <v-list>
              <v-list-item href="https://discord.gg/8VHuXsrCQm" target="_blank">
                <v-list-item-title >Discord</v-list-item-title>
              </v-list-item>
              <v-list-item link :to="{name: 'faq'}">
                <v-list-item-title >FAQ</v-list-item-title>
              </v-list-item>
              <v-list-item link :to="{name: 'imprint'}">
                <v-list-item-title >impressum</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>

      <!-- Mobile sidebar toggle for logged-in users / viewer pages -->
      <v-btn
        icon
        class="hidden-md-and-up"
        v-if="showMobileDrawerToggle"
        @click="toggleMobileDrawer"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <v-spacer class="hidden-md-and-up"></v-spacer>

      <!-- Mobile hamburger menu -->
      <v-menu offset-y class="hidden-md-and-up">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            class="hidden-md-and-up"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/'">
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{name: 'pricing'}">
            <v-list-item-title>Funktionen</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="showShop" :to="{name: 'shop'}">
            <v-list-item-title>Shop</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{name: 'about'}">
            <v-list-item-title>Über uns</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item href="https://discord.gg/8VHuXsrCQm" target="_blank">
            <v-list-item-title>Discord</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{name: 'faq'}">
            <v-list-item-title>FAQ</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{name: 'imprint'}">
            <v-list-item-title>Impressum</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu offset-y
        v-if="!$store.state.logged_in && discordLoginEnabled"
      >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Login
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-title>
            <v-btn
              tile
              color="#9147ff"
              class="text--white"
              :href="loginUrl"
            >
              <v-icon left>
                mdi-twitch
              </v-icon>
              Login mit Twitch
            </v-btn>
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>
            <v-btn
              tile
              color="#5865f2"
              class="text--white"
              :href="loginUrlDiscord"
            >
              <v-icon left>
                fa-brands fa-discord
              </v-icon>
              Login mit Discord
            </v-btn>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn
    v-else-if="!$store.state.logged_in"
              tile
              color="#9147ff"
              class="text--white"
              :href="loginUrl"
            >
              <v-icon left>
                mdi-twitch
              </v-icon>
              Login mit Twitch
            </v-btn>

    </v-toolbar>
    <!-- Navigation drawer outside v-layout so it doesn't affect v-main padding -->
    <v-navigation-drawer
      v-model="drawerVisible"
      :permanent="$vuetify.breakpoint.mdAndUp"
      :temporary="$vuetify.breakpoint.smAndDown"
      :expand-on-hover="$vuetify.breakpoint.mdAndUp"
      v-if="showNavigationDrawer"
      :mini-variant="$vuetify.breakpoint.mdAndUp ? navigationDrawerMini : false"
      @update:mini-variant="navigationDrawerMini = $event"
      width="300"
      fixed
    >
      <v-list>
        <v-list-item class="px-2" v-if="$store.state.avatar">
          <v-list-item-avatar>
            <v-img :src="$store.state.avatar"></v-img>
          </v-list-item-avatar>
        </v-list-item>

        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="text-h6" @click="$router.push({ name: 'home' })">
              {{ $store.state.username }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="false">business@just-dean.de</v-list-item-subtitle>
            <v-list-item-subtitle v-if="$store.state.user_perm > 3">Twitch Rang: {{ $store.state.permname }}</v-list-item-subtitle>
            <v-list-item-subtitle v-if="$store.state.tiktok_user_perm > 3">TikTok Rang: {{ $store.state.tiktok_permname }}</v-list-item-subtitle>
            <v-list-item-subtitle v-if="$store.state.instanz !== null">
              ------------------------------</v-list-item-subtitle>
            <v-list-item-subtitle v-if="$store.state.instanz !== null">
              Instanz: {{$store.state.instanz}}</v-list-item-subtitle>
            <v-list-item-subtitle>Version: {{ app_version }} </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-list-group
          :value="false"
          prepend-icon="mdi-account-circle"
          v-if="$store.state.user_perm >= 8"
        >
          <template v-slot:activator>
            <v-list-item-title>Administration</v-list-item-title>
          </template>
          <v-list-item link @click="$router.push({ name: 'newbot' })"
                       v-if="$store.state.user_perm >= 8"
          >
            <v-list-item-icon>
              <v-icon>mdi-twitch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Bot erstellen</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'global-xp-settings' })"
                       v-if="$store.state.user_perm >= 8"
          >
            <v-list-item-icon>
              <v-icon>mdi-twitch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Global XP Settings</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'licenses-admin' })"
                       v-if="$store.state.user_perm >= 8"
          >
            <v-list-item-icon>
              <v-icon>mdi-key</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Lizenzen</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'chat-sender-config' })"
                       v-if="$store.state.user_perm >= 8"
          >
            <v-list-item-icon>
              <v-icon>mdi-chat-processing</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Chat-Sender-App</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          :value="false"
          prepend-icon="mdi-account-circle"
          v-if="$store.state.user_perm >= 4"
        >
          <template v-slot:activator>
            <v-list-item-title>Twitch-Bot</v-list-item-title>
          </template>
          <v-list-item link @click="$router.push({ name: 'profil' })"
                       v-if="$store.state.user_perm >= 7"
          >
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Profil</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'bot_state' })"
                       v-if="$store.state.user_perm >= 5"
          >
            <v-list-item-icon>
              <v-icon>mdi-robot-dead</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Bot Status</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'commands' })"
                       v-if="$store.state.user_perm >= 4"
          >
            <v-list-item-icon>
              <v-icon>mdi-cog-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Commands</v-list-item-title>
          </v-list-item>
          <v-list-item link  @click="$router.push({ name: 'ccomands' })"
                       v-if="$store.state.user_perm >= 4"
          >
            <v-list-item-icon>
              <v-icon>mdi-account-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Custom Commands</v-list-item-title>
          </v-list-item>
          <v-list-item link  @click="$router.push({ name: 'interval_msg' })"
                       v-if="$store.state.user_perm >= 5"
          >
            <v-list-item-icon>
              <v-icon>mdi-message</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Auto Nachrichten</v-list-item-title>
          </v-list-item>
          <v-list-group
            :value="false"
            no-action
            sub-group
            v-if="$store.state.user_perm >= 5"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title >Loyaltiy System <span class="new-badge">NEU</span></v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item link  @click="$router.push({ name: 'loyality' })"
                         v-if="$store.state.user_perm >= 5"
            >
              <v-list-item-icon>
                <v-icon>mdi-cog-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Loyality Points</v-list-item-title>
            </v-list-item>

            <v-list-item link  @click="$router.push({ name: 'monthly' })"
                         v-if="$store.state.user_perm >= 5"
            >
              <v-list-item-icon>
                <v-icon>mdi-cog-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Monthly Points</v-list-item-title>
            </v-list-item>
            <v-list-item link  @click="$router.push({ name: 'mhp' })"
                         v-if="$store.state.user_perm >= 5"
            >
              <v-list-item-icon>
                <v-icon>mdi-cog-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Monthly History</v-list-item-title>
            </v-list-item>
            <v-list-item link  @click="$router.push({ name: 'xp_settings' })"
                         v-if="$store.state.user_perm >= 5"
            >
              <v-list-item-icon>
                <v-icon>mdi-cog-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>XP Settings <span class="new-badge">NEU</span></v-list-item-title>
            </v-list-item>
            <v-list-item link  @click="$router.push({ name: 'rune_editor' })"
                         v-if="$store.state.user_perm >= 5"
            >
              <v-list-item-icon>
                <v-icon>mdi-cog-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Rune Editor <span class="new-badge">NEU</span></v-list-item-title>
            </v-list-item>
            <v-list-item link  @click="$router.push({ name: 'points_exclusion' })"
                         v-if="$store.state.user_perm >= 5 && showMain"
            >
              <v-list-item-icon>
                <v-icon>mdi-account-cancel-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Punkte-Ausschluss <span class="new-badge">NEU</span></v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group
            :value="false"
            no-action
            sub-group
            v-if="$store.state.user_perm >= 6"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title >Giveaway</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item link  @click="$router.push({ name: 'giveawaysettings' })"
                         v-if="$store.state.user_perm >= 6"
            >
              <v-list-item-icon>
                <v-icon>mdi-ticket</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Loyality</v-list-item-title>
            </v-list-item>

            <v-list-item link  @click="$router.push({ name: 'giveawayNoPoints' })"
                         v-if="$store.state.user_perm >= 5"
            >
              <v-list-item-icon>
                <v-icon>mdi-ticket</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Chat</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-item link  @click="$router.push({ name: 'ccs' })"
                       v-if="$store.state.user_perm >= 5"
          >
            <v-list-item-icon>
              <v-icon>mdi-cog-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item>
          <v-list-item link  @click="$router.push({ name: 'link_protection' })"
                       v-if="$store.state.user_perm >= 5 && showMain"
          >
            <v-list-item-icon>
              <v-icon>mdi-link-off</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Link Protection <span class="new-badge">NEU</span></v-list-item-title>
          </v-list-item>

          <v-list-group
            :value="false"
            no-action
            sub-group
            v-if="$store.state.user_perm >= 7"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title >Integrationen <span class="new-badge">NEU</span></v-list-item-title>
              </v-list-item-content>
            </template>
          <v-list-item link @click="$router.push({ name: 'thofu_connect' })"
                       v-if="$store.state.user_perm >= 7 && showMain"
          >
            <v-list-item-icon>
              <v-icon>mdi-laptop</v-icon>
            </v-list-item-icon>
            <v-list-item-title>ThoFu_Bot Connect  <span class="new-badge">NEU</span></v-list-item-title>
          </v-list-item>
            <v-list-item link @click="$router.push({ name: 'obs' })"
                       v-if="$store.state.user_perm >= 7"
          >
            <v-list-item-icon>
              <v-icon>mdi-broadcast</v-icon>
            </v-list-item-icon>
            <v-list-item-title>OBS Integration</v-list-item-title>
          </v-list-item>
          </v-list-group>
          <v-list-item link @click="$router.push({ name: 'subathon' })"
                       v-if="$store.state.user_perm >= 6"
          >
            <v-list-item-icon>
              <v-icon>mdi-twitch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Subathon Timer Settings</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'cp' })"
                       v-if="$store.state.user_perm >= 5"
          >
            <v-list-item-icon>
              <v-icon>mdi-twitch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Kanalpunkte</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'loyality_rewards_settings' })"
                       v-if="$store.state.user_perm >= 5 && showLoyalityRewards"
          >
            <v-list-item-icon>
              <v-icon>mdi-twitch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Loyaltiy Rewards</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'user_sound_settings' })"
                       v-if="$store.state.user_perm >= 5 && showMain"
          >
            <v-list-item-icon>
              <v-icon>mdi-account-voice</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Usersounds <span class="new-badge">NEU</span></v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'loyality_reward_list' })"
                       v-if="$store.state.user_perm >= 4 && showBelohnungsanfragen"
          >
            <v-list-item-icon>
              <v-icon>mdi-twitch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Belohnungsanfragen</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'loyality_reward_history' })"
                       v-if="$store.state.user_perm >= 4 && showBelohnungsanfragen"
          >
            <v-list-item-icon>
              <v-icon>mdi-twitch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Belohnungsanfragenverlauf</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'overlay' })"
                       v-if="$store.state.user_perm >= 5"
          >
            <v-list-item-icon>
              <v-icon>mdi-layers-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Overlays [WIP!]</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          :value="false"
          prepend-icon="mdi-account-circle"
          v-if="$store.state.tiktok_user_perm >= 4"
        >
          <template v-slot:activator>
            <v-list-item-title>TikTok Bot</v-list-item-title>
          </template>
          <v-list-item link @click="$router.push({ name: 'ttcommands' })"
                       v-if="$store.state.tiktok_user_perm >= 4"
          >
            <v-list-item-icon>
              <v-icon>mdi-twitch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Commands</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'ttccommands' })"
                       v-if="$store.state.tiktok_user_perm >= 4"
          >
            <v-list-item-icon>
              <v-icon>mdi-twitch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Custom Commands</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'ttloyality' })"
                       v-if="$store.state.tiktok_user_perm >= 5"
          >
            <v-list-item-icon>
              <v-icon>mdi-twitch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Loyality Settings</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'ttcs' })"
                       v-if="$store.state.tiktok_user_perm >= 5"
          >
            <v-list-item-icon>
              <v-icon>mdi-twitch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'newbot' })"
                       v-if="$store.state.tiktok_user_perm >= 5"
          >
            <v-list-item-icon>
              <v-icon>mdi-twitch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>---------------</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          :value="false"
          prepend-icon="mdi-account-circle"
          v-if="$store.state.user_perm >= 6 && showMain"
        >
          <template v-slot:activator>
            <v-list-item-title>Discord-Bot <span class="new-badge">NEU</span></v-list-item-title>
          </template>
          <v-list-item link @click="$router.push({ name: 'onboarding' })"
                       v-if="$store.state.user_perm >= 6"
          >
            <v-list-item-icon>
              <v-icon>mdi-rocket-launch-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Onboarding <span class="new-badge">NEU</span></v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'my_servers' })"
                       v-if="$store.state.user_perm >= 6"
          >
            <v-list-item-icon>
              <v-icon>mdi-server</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Meine Server <span class="new-badge">NEU</span></v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'live_announcement' })"
                       v-if="$store.state.user_perm >= 6"
          >
            <v-list-item-icon>
              <v-icon>mdi-twitch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Live-Ankündigungen <span class="new-badge">NEU</span></v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'youtube_announcement' })"
                       v-if="$store.state.user_perm >= 6"
          >
            <v-list-item-icon>
              <v-icon>mdi-youtube</v-icon>
            </v-list-item-icon>
            <v-list-item-title>YouTube-Ankündigungen <span class="new-badge">NEU</span></v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'instagram_announcement' })"
                       v-if="$store.state.user_perm >= 8"
          >
            <v-list-item-icon>
              <v-icon>mdi-instagram</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Instagram-Ankündigungen [WIP] <span class="new-badge">NEU</span></v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'ticket_system' })"
                       v-if="$store.state.user_perm >= 6"
          >
            <v-list-item-icon>
              <v-icon>mdi-ticket-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Ticket-System <span class="new-badge">NEU</span></v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'stream_plan' })"
                       v-if="$store.state.user_perm >= 6"
          >
            <v-list-item-icon>
              <v-icon>mdi-calendar-text</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Stream-Plan <span class="new-badge">NEU</span></v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'rules' })"
                       v-if="$store.state.user_perm >= 6"
          >
            <v-list-item-icon>
              <v-icon>mdi-book-open-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Regelwerk <span class="new-badge">NEU</span></v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'temp_voice' })"
                       v-if="$store.state.user_perm >= 6"
          >
            <v-list-item-icon>
              <v-icon>mdi-account-voice</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Temporäre Sprachkanäle <span class="new-badge">NEU</span></v-list-item-title>
          </v-list-item>
          <v-list-item link @click="$router.push({ name: 'role_sync' })"
                       v-if="$store.state.user_perm >= 6"
          >
            <v-list-item-icon>
              <v-icon>mdi-account-sync</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Rollen-Sync <span class="new-badge">NEU</span></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item link @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="viewerMobileDrawerOpen"
      :permanent="$vuetify.breakpoint.mdAndUp"
      :temporary="$vuetify.breakpoint.smAndDown"
      :expand-on-hover="$vuetify.breakpoint.mdAndUp"
      fixed
      v-if="$route.meta.isViewerPublic && !$route.meta.isOverlay"
      :mini-variant="$vuetify.breakpoint.mdAndUp ? viewerDrawerMini : false"
      @update:mini-variant="viewerDrawerMini = $event"
      width="220"
    >
      <v-list>
        <v-list-item class="px-2" v-if="$store.state.avatar">
          <v-list-item-avatar>
            <v-img :src="$store.state.avatar"></v-img>
          </v-list-item-avatar>
        </v-list-item>
        <v-list-item class="px-2" v-else>
          <v-list-item-avatar>
            <v-icon large>mdi-account-group</v-icon>
          </v-list-item-avatar>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              {{ $store.state.username || 'Navigation' }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="viewerInstanz">
              Instanz: {{ viewerInstanz }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>Version: {{ app_version }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list-item
          link
          v-if="viewerPublicId"
          @click="$router.push({ name: 'commandlist', params: { id: viewerPublicId } })"
        >
          <v-list-item-icon>
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Commands</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          v-if="viewerPublicId"
          @click="$router.push({ name: 'loyality_rewards', params: { id: viewerPublicId } })"
        >
          <v-list-item-icon>
            <v-icon>mdi-gift-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Loyalty Rewards</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          v-if="viewerPublicId"
          @click="$router.push({ name: 'point_credit_log', params: { id: viewerPublicId } })"
        >
          <v-list-item-icon>
            <v-icon>mdi-history</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Meine Gutschriften</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          v-if="viewerPublicId"
          @click="$router.push({ name: 'rune_shop', params: { id: viewerPublicId } })"
        >
          <v-list-item-icon>
            <v-icon>mdi-diamond-stone</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Rune Shop</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          v-if="viewerPublicId"
          @click="$router.push({ name: 'equipment_selection', params: { id: viewerPublicId } })"
        >
          <v-list-item-icon>
            <v-icon>mdi-sword</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Equipment</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          @click="$router.push({ name: 'equipment_shop', query: viewerPublicId ? { from: viewerPublicId } : {} })"
        >
          <v-list-item-icon>
            <v-icon>mdi-store-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Equipment Shop</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          v-if="$store.state.logged_in"
          @click="logout"
        >
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-layout v-if="$store.state.state_loaded">
      <v-main :class="{
        'drawer-open': !navigationDrawerMini && $vuetify.breakpoint.mdAndUp && !$route.meta.isViewerPublic,
        'viewer-drawer-open': !viewerDrawerMini && $vuetify.breakpoint.mdAndUp && $route.meta.isViewerPublic,
        'no-drawer': !showNavigationDrawer && !viewerDrawerPresent,
      }">
        <router-view v-if="publicOrLoggedin" />
        <v-container v-else>
          <img src="/img/thor.png" alt="Logo" class="logo">
          <center>
          <h1>Login</h1>
          <v-btn
            tile
            color="#9147ff"
            class="text--white"
            :href="loginUrl"
          >
            <v-icon left>
              mdi-twitch
            </v-icon>
            Login mit Twitch
          </v-btn>
          </center>
        </v-container>
      </v-main>
    </v-layout>
    <v-footer v-if="!$route.meta.isOverlay">
      <v-row
        justify="center"
        no-gutters
      >
        <v-col
          class="py-4 text-center white--text"
          cols="12"
        >
          <v-btn
            color="white"
            text
            rounded
            class="my-2"
            :to="{name: 'imprint'}"
          >
            Impressum
          </v-btn>
          <v-btn
            color="white"
            text
            rounded
            class="my-2"
            :to="{name: 'tos'}"
            href="/agb"
          >
            AGB
          </v-btn>
          © {{ new Date().getFullYear() }} — <strong>ThoFu_Bot</strong>
        </v-col>
      </v-row>    </v-footer>
    <!-- <div>
      <input v-model="testInput"><br />
      TestInputL: {{testInput}}<br />
      x{{ loggedIn }}x
      <a href="#" @click="loggedIn = !loggedIn">xx</a>
    </div> -->
    <v-snackbar
      v-model="loginError"
      timeout="3000"
      color="red"
    >
      Login fehlgeschlagen

      <template v-slot:actions>
        <v-btn
          color="pink"
          variant="text"
          @click="loginError = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import BackendService from '@/services/BackendService';

export default {
  name: 'App',

  data: () => ({
    app_version: '',
    testInput: '',
    showPassword: false,
    username: '',
    password: '',
    loginLoading: false,
    loginError: false,
    navigationDrawerMini: true,
    viewerDrawerMini: true,
    viewerPublicId: null,
    viewerInstanz: null,
    mobileDrawerOpen: false,
    desktopDrawerOpen: true,
    viewerMobileDrawerOpen: false,
  }),
  watch: {
    navigationDrawerMini(newValue) {
      this.$store.commit('set_navigation_drawer_mini', newValue);
    },
    $route(to) {
      this.initViewerPublicId(to);
    },
  },
  created() {
    this.app_version = process.env.VUE_APP_VERSION;
    this.initViewerPublicId(this.$route);
    this.$store.dispatch('refreshStatus');
  },
  computed: {
    drawerVisible: {
      get() {
        return this.$vuetify.breakpoint.smAndDown ? this.mobileDrawerOpen : this.desktopDrawerOpen;
      },
      set(val) {
        if (this.$vuetify.breakpoint.smAndDown) {
          this.mobileDrawerOpen = val;
        } else {
          this.desktopDrawerOpen = val;
        }
      },
    },
    showNavigationDrawer() {
      return this.$store.state.state_loaded && this.$store.state.logged_in && this.$store.state.user_perm > -2
        && this.$router.currentRoute.name !== 'editoverlay'
        && !this.$router.currentRoute.meta.isOverlay
        && !this.$router.currentRoute.meta.isViewerPublic;
    },
    viewerDrawerPresent() {
      return this.$route.meta.isViewerPublic && !this.$route.meta.isOverlay;
    },
    showMobileDrawerToggle() {
      if (this.$route.meta.isViewerPublic) {
        return !this.$route.meta.isOverlay;
      }
      return this.$store.state.logged_in && this.$store.state.user_perm > -2;
    },
    discordLoginEnabled() {
      return !!process.env.VUE_APP_DISCORD_LOGIN_ENABLED;
    },
    showLoyalityRewards() {
      return !!process.env.VUE_APP_SHOW_LOYALITY_REWARDS;
    },
    showBelohnungsanfragen() {
      return !!process.env.VUE_APP_SHOW_BELOHNUNGSANFRAGEN;
    },
    showShop() {
      return !!process.env.VUE_APP_SHOP_ENABLED;
    },
    showMain() {
      return process.env.VUE_APP_MAIN !== 'true';
    },
    publicOrLoggedin() {
      return (this.$route.meta && this.$route.meta.isPublic === true)
        || this.$store.state.logged_in;
    },
    loginUrl() {
      const base = `https://id.twitch.tv/oauth2/authorize?response_type=code&client_id=${process.env.VUE_APP_TWITCH_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_TWITCH_REDIRECT_URL}&scope=user%3Aread%3Aemail`;
      const stateMap = {
        giveaway: `giveaway|${this.$route.params.id}`,
        loyality_rewards: `rewards|${this.$route.params.id}`,
        point_credit_log: `point_credit_log|${this.$route.params.id}`,
        rune_shop: `rune_shop|${this.$route.params.id}`,
        equipment_selection: `equipment|${this.$route.params.id}`,
        equipment_shop: `equipment_shop|${this.$route.path}`,
      };
      const state = stateMap[this.$route.name];
      return state ? `${base}&state=${state}` : base;
    },
    loginUrlDiscord() {
      return `https://discord.com/oauth2/authorize?client_id=${process.env.VUE_APP_DISCORD_CLIENT_ID}&response_type=code&redirect_uri=${process.env.VUE_APP_DISCORD_REDIRECT_URL}&scope=identify+email&state=discord`;
    },
  },
  methods: {
    toggleMobileDrawer() {
      if (this.$route.meta.isViewerPublic) {
        this.viewerMobileDrawerOpen = !this.viewerMobileDrawerOpen;
      } else {
        this.mobileDrawerOpen = !this.mobileDrawerOpen;
      }
    },
    initViewerPublicId(route) {
      if (!route.meta.isViewerPublic) return;
      const pubId = route.params.id || route.query.from;
      if (pubId) {
        this.viewerPublicId = pubId;
        this.loadViewerInstanz(pubId);
      }
    },
    loadViewerInstanz(pubId) {
      BackendService.getInstanzByPubId(pubId).then((data) => {
        this.viewerInstanz = data.data.instanz;
      }).catch(() => {});
    },
    logout() {
      BackendService.logout().then((data) => {
        this.$store.commit('set_loggedin', data.data === 1);
        this.$store.commit('set_username', '');
        this.$store.commit('set_avatar', null);
        this.$store.commit('set_permname', null);
        this.$store.commit('set_user_perm', null);
        this.$store.commit('set_loyaltypoints', 0);
        this.$store.commit('set_loyaltypoints_name', null);
        this.$store.commit('set_monthlypoints_name', null);
        this.$store.commit('set_ticket', 0);
        this.$store.commit('set_instanz', null);
        this.$store.commit('set_tiktok_user_perm', null);
        this.$store.commit('set_tiktok_db', null);
        this.$store.commit('set_tiktok_loyaltypoints', 0);
        this.$store.commit('set_tiktok_broadcasterId', null);
        this.$store.commit('set_xp', 0);
        this.$store.commit('set_xp_name', null);
        this.$store.commit('set_xp_global', 0);
        this.$store.commit('set_xp_name_global', null);
        localStorage.clear();
        if (this.$router.currentRoute.path !== '/') {
          this.$router.push('/');
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
// v-main defaults to flex: 1 0 auto with no explicit width. Combined with margin-left
// alone, a flex-wrap grid inside (e.g. reward cards wrapping to a partial last row) can
// make the browser compute v-main's intrinsic content size as if nothing wrapped, forcing
// it to grow past its available space (up to max-width: 100%, ignoring its own margin) and
// overflow the viewport by exactly the margin amount. An explicit width tied to the same
// margin forces definite sizing instead, so content-driven growth can't push it wider.
.v-main {
  margin-left: 56px;
  width: calc(100% - 56px);

  &.drawer-open {
    margin-left: 300px;
    width: calc(100% - 300px);
  }

  &.viewer-drawer-open {
    margin-left: 220px;
    width: calc(100% - 220px);
  }

  &.no-drawer {
    margin-left: 0;
    width: 100%;
  }
}

@media (max-width: 960px) {
  .v-main {
    margin-left: 0 !important;
    width: 100% !important;
  }
}

</style>
<style lang="scss">
.v-navigation-drawer {
  flex-shrink: 0;
}

.v-navigation-drawer__content {
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.logo {
  max-width: 300px;
  margin: 0 auto;
  display: block;
  border-radius: 25%;
}

.theme--light.v-btn.text--white {
  color: white;
}

.v-main__wrap {
  padding-bottom: 25px;
}

.thofu-menu {
  .button, .v-btn {
    margin: 0 5px;
  }
}

.new-badge {
  display: inline-block;
  background: linear-gradient(135deg, #ff6b00, #ffcc00);
  color: #1a1a1a;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.5px;
  padding: 2px 6px;
  border-radius: 4px;
  vertical-align: middle;
  margin-left: 4px;
  animation: new-badge-pulse 1.6s ease-in-out infinite;
}

@keyframes new-badge-pulse {
  0%, 100% {
    box-shadow: 0 0 4px 1px rgba(255, 160, 0, 0.5);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 10px 3px rgba(255, 160, 0, 0.9);
    transform: scale(1.08);
  }
}

/* fallback */
@font-face {
  font-family: 'Playwrite MX Guides';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(../public/fonts/playwritemxguides/v1/k3kMo9ESPe9dzQ1UGbvoZhnhbtfklWqN0qk.woff2) format('woff2');
}
/* cyrillic-ext */
@font-face {
  font-family: 'Roboto';
  font-style: italic;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOkCnqEu92Fr1Mu51xFIzIFKw.woff2) format('woff2');
  unicode-range: U+0460-052F, U+1C80-1C8A, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: 'Roboto';
  font-style: italic;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOkCnqEu92Fr1Mu51xMIzIFKw.woff2) format('woff2');
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* greek-ext */
@font-face {
  font-family: 'Roboto';
  font-style: italic;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOkCnqEu92Fr1Mu51xEIzIFKw.woff2) format('woff2');
  unicode-range: U+1F00-1FFF;
}
/* greek */
@font-face {
  font-family: 'Roboto';
  font-style: italic;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOkCnqEu92Fr1Mu51xLIzIFKw.woff2) format('woff2');
  unicode-range: U+0370-0377, U+037A-037F, U+0384-038A, U+038C, U+038E-03A1, U+03A3-03FF;
}
/* math */
@font-face {
  font-family: 'Roboto';
  font-style: italic;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOkCnqEu92Fr1Mu51w0IzIFKw.woff2) format('woff2');
  unicode-range: U+0302-0303, U+0305, U+0307-0308, U+0310, U+0312, U+0315, U+031A, U+0326-0327, U+032C, U+032F-0330, U+0332-0333, U+0338, U+033A, U+0346, U+034D, U+0391-03A1, U+03A3-03A9, U+03B1-03C9, U+03D1, U+03D5-03D6, U+03F0-03F1, U+03F4-03F5, U+2016-2017, U+2034-2038, U+203C, U+2040, U+2043, U+2047, U+2050, U+2057, U+205F, U+2070-2071, U+2074-208E, U+2090-209C, U+20D0-20DC, U+20E1, U+20E5-20EF, U+2100-2112, U+2114-2115, U+2117-2121, U+2123-214F, U+2190, U+2192, U+2194-21AE, U+21B0-21E5, U+21F1-21F2, U+21F4-2211, U+2213-2214, U+2216-22FF, U+2308-230B, U+2310, U+2319, U+231C-2321, U+2336-237A, U+237C, U+2395, U+239B-23B7, U+23D0, U+23DC-23E1, U+2474-2475, U+25AF, U+25B3, U+25B7, U+25BD, U+25C1, U+25CA, U+25CC, U+25FB, U+266D-266F, U+27C0-27FF, U+2900-2AFF, U+2B0E-2B11, U+2B30-2B4C, U+2BFE, U+3030, U+FF5B, U+FF5D, U+1D400-1D7FF, U+1EE00-1EEFF;
}
/* symbols */
@font-face {
  font-family: 'Roboto';
  font-style: italic;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOkCnqEu92Fr1Mu51wmIzIFKw.woff2) format('woff2');
  unicode-range: U+0001-000C, U+000E-001F, U+007F-009F, U+20DD-20E0, U+20E2-20E4, U+2150-218F, U+2190, U+2192, U+2194-2199, U+21AF, U+21E6-21F0, U+21F3, U+2218-2219, U+2299, U+22C4-22C6, U+2300-243F, U+2440-244A, U+2460-24FF, U+25A0-27BF, U+2800-28FF, U+2921-2922, U+2981, U+29BF, U+29EB, U+2B00-2BFF, U+4DC0-4DFF, U+FFF9-FFFB, U+10140-1018E, U+10190-1019C, U+101A0, U+101D0-101FD, U+102E0-102FB, U+10E60-10E7E, U+1D2C0-1D2D3, U+1D2E0-1D37F, U+1F000-1F0FF, U+1F100-1F1AD, U+1F1E6-1F1FF, U+1F30D-1F30F, U+1F315, U+1F31C, U+1F31E, U+1F320-1F32C, U+1F336, U+1F378, U+1F37D, U+1F382, U+1F393-1F39F, U+1F3A7-1F3A8, U+1F3AC-1F3AF, U+1F3C2, U+1F3C4-1F3C6, U+1F3CA-1F3CE, U+1F3D4-1F3E0, U+1F3ED, U+1F3F1-1F3F3, U+1F3F5-1F3F7, U+1F408, U+1F415, U+1F41F, U+1F426, U+1F43F, U+1F441-1F442, U+1F444, U+1F446-1F449, U+1F44C-1F44E, U+1F453, U+1F46A, U+1F47D, U+1F4A3, U+1F4B0, U+1F4B3, U+1F4B9, U+1F4BB, U+1F4BF, U+1F4C8-1F4CB, U+1F4D6, U+1F4DA, U+1F4DF, U+1F4E3-1F4E6, U+1F4EA-1F4ED, U+1F4F7, U+1F4F9-1F4FB, U+1F4FD-1F4FE, U+1F503, U+1F507-1F50B, U+1F50D, U+1F512-1F513, U+1F53E-1F54A, U+1F54F-1F5FA, U+1F610, U+1F650-1F67F, U+1F687, U+1F68D, U+1F691, U+1F694, U+1F698, U+1F6AD, U+1F6B2, U+1F6B9-1F6BA, U+1F6BC, U+1F6C6-1F6CF, U+1F6D3-1F6D7, U+1F6E0-1F6EA, U+1F6F0-1F6F3, U+1F6F7-1F6FC, U+1F700-1F7FF, U+1F800-1F80B, U+1F810-1F847, U+1F850-1F859, U+1F860-1F887, U+1F890-1F8AD, U+1F8B0-1F8BB, U+1F8C0-1F8C1, U+1F900-1F90B, U+1F93B, U+1F946, U+1F984, U+1F996, U+1F9E9, U+1FA00-1FA6F, U+1FA70-1FA7C, U+1FA80-1FA89, U+1FA8F-1FAC6, U+1FACE-1FADC, U+1FADF-1FAE9, U+1FAF0-1FAF8, U+1FB00-1FBFF;
}
/* vietnamese */
@font-face {
  font-family: 'Roboto';
  font-style: italic;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOkCnqEu92Fr1Mu51xHIzIFKw.woff2) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Roboto';
  font-style: italic;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOkCnqEu92Fr1Mu51xGIzIFKw.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Roboto';
  font-style: italic;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOkCnqEu92Fr1Mu51xIIzI.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOmCnqEu92Fr1Mu72xKOzY.woff2) format('woff2');
  unicode-range: U+0460-052F, U+1C80-1C8A, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOmCnqEu92Fr1Mu5mxKOzY.woff2) format('woff2');
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* greek-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOmCnqEu92Fr1Mu7mxKOzY.woff2) format('woff2');
  unicode-range: U+1F00-1FFF;
}
/* greek */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOmCnqEu92Fr1Mu4WxKOzY.woff2) format('woff2');
  unicode-range: U+0370-0377, U+037A-037F, U+0384-038A, U+038C, U+038E-03A1, U+03A3-03FF;
}
/* math */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOmCnqEu92Fr1MunmxKOzY.woff2) format('woff2');
  unicode-range: U+0302-0303, U+0305, U+0307-0308, U+0310, U+0312, U+0315, U+031A, U+0326-0327, U+032C, U+032F-0330, U+0332-0333, U+0338, U+033A, U+0346, U+034D, U+0391-03A1, U+03A3-03A9, U+03B1-03C9, U+03D1, U+03D5-03D6, U+03F0-03F1, U+03F4-03F5, U+2016-2017, U+2034-2038, U+203C, U+2040, U+2043, U+2047, U+2050, U+2057, U+205F, U+2070-2071, U+2074-208E, U+2090-209C, U+20D0-20DC, U+20E1, U+20E5-20EF, U+2100-2112, U+2114-2115, U+2117-2121, U+2123-214F, U+2190, U+2192, U+2194-21AE, U+21B0-21E5, U+21F1-21F2, U+21F4-2211, U+2213-2214, U+2216-22FF, U+2308-230B, U+2310, U+2319, U+231C-2321, U+2336-237A, U+237C, U+2395, U+239B-23B7, U+23D0, U+23DC-23E1, U+2474-2475, U+25AF, U+25B3, U+25B7, U+25BD, U+25C1, U+25CA, U+25CC, U+25FB, U+266D-266F, U+27C0-27FF, U+2900-2AFF, U+2B0E-2B11, U+2B30-2B4C, U+2BFE, U+3030, U+FF5B, U+FF5D, U+1D400-1D7FF, U+1EE00-1EEFF;
}
/* symbols */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOmCnqEu92Fr1MujGxKOzY.woff2) format('woff2');
  unicode-range: U+0001-000C, U+000E-001F, U+007F-009F, U+20DD-20E0, U+20E2-20E4, U+2150-218F, U+2190, U+2192, U+2194-2199, U+21AF, U+21E6-21F0, U+21F3, U+2218-2219, U+2299, U+22C4-22C6, U+2300-243F, U+2440-244A, U+2460-24FF, U+25A0-27BF, U+2800-28FF, U+2921-2922, U+2981, U+29BF, U+29EB, U+2B00-2BFF, U+4DC0-4DFF, U+FFF9-FFFB, U+10140-1018E, U+10190-1019C, U+101A0, U+101D0-101FD, U+102E0-102FB, U+10E60-10E7E, U+1D2C0-1D2D3, U+1D2E0-1D37F, U+1F000-1F0FF, U+1F100-1F1AD, U+1F1E6-1F1FF, U+1F30D-1F30F, U+1F315, U+1F31C, U+1F31E, U+1F320-1F32C, U+1F336, U+1F378, U+1F37D, U+1F382, U+1F393-1F39F, U+1F3A7-1F3A8, U+1F3AC-1F3AF, U+1F3C2, U+1F3C4-1F3C6, U+1F3CA-1F3CE, U+1F3D4-1F3E0, U+1F3ED, U+1F3F1-1F3F3, U+1F3F5-1F3F7, U+1F408, U+1F415, U+1F41F, U+1F426, U+1F43F, U+1F441-1F442, U+1F444, U+1F446-1F449, U+1F44C-1F44E, U+1F453, U+1F46A, U+1F47D, U+1F4A3, U+1F4B0, U+1F4B3, U+1F4B9, U+1F4BB, U+1F4BF, U+1F4C8-1F4CB, U+1F4D6, U+1F4DA, U+1F4DF, U+1F4E3-1F4E6, U+1F4EA-1F4ED, U+1F4F7, U+1F4F9-1F4FB, U+1F4FD-1F4FE, U+1F503, U+1F507-1F50B, U+1F50D, U+1F512-1F513, U+1F53E-1F54A, U+1F54F-1F5FA, U+1F610, U+1F650-1F67F, U+1F687, U+1F68D, U+1F691, U+1F694, U+1F698, U+1F6AD, U+1F6B2, U+1F6B9-1F6BA, U+1F6BC, U+1F6C6-1F6CF, U+1F6D3-1F6D7, U+1F6E0-1F6EA, U+1F6F0-1F6F3, U+1F6F7-1F6FC, U+1F700-1F7FF, U+1F800-1F80B, U+1F810-1F847, U+1F850-1F859, U+1F860-1F887, U+1F890-1F8AD, U+1F8B0-1F8BB, U+1F8C0-1F8C1, U+1F900-1F90B, U+1F93B, U+1F946, U+1F984, U+1F996, U+1F9E9, U+1FA00-1FA6F, U+1FA70-1FA7C, U+1FA80-1FA89, U+1FA8F-1FAC6, U+1FACE-1FADC, U+1FADF-1FAE9, U+1FAF0-1FAF8, U+1FB00-1FBFF;
}
/* vietnamese */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOmCnqEu92Fr1Mu7WxKOzY.woff2) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOmCnqEu92Fr1Mu7GxKOzY.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 100 900;
  font-stretch: 75% 100%;
  font-display: swap;
  src: url(../public/fonts/roboto/v47/KFOmCnqEu92Fr1Mu4mxK.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic */
@font-face {
  font-family: 'Underdog';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(../public/fonts/underdog/v23/CHygV-jCElj7diMroWShWV82Nw.woff2) format('woff2');
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* latin-ext */
@font-face {
  font-family: 'Underdog';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(../public/fonts/underdog/v23/CHygV-jCElj7diMroWSrWV82Nw.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Underdog';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(../public/fonts/underdog/v23/CHygV-jCElj7diMroWSlWV8.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

</style>
